'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _sharedTypeUtils = require('../shared/type-utils');

var _utilsClone = require('../utils/clone');

var _utilsClone2 = _interopRequireDefault(_utilsClone);

var _utilsBaseValidator = require('../utils/base-validator');

var _errors = require('../errors');

/**
 * @class WixDataSort
 * @description Provides functionality for sorting a query.
 * @memberof wix-data
 */
var sortMixin = function sortMixin() {
  var Base = arguments.length <= 0 || arguments[0] === undefined ? (function () {
    function _class() {
      _classCallCheck(this, _class);
    }

    return _class;
  })() : arguments[0];
  return (function (_Base) {
    _inherits(_class2, _Base);

    function _class2() {
      var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

      _classCallCheck(this, _class2);

      _get(Object.getPrototypeOf(_class2.prototype), 'constructor', this).call(this, obj);
      this.orderBy = obj.orderBy || [];
      this.invalidArguments = obj.invalidArguments || [];
    }

    /**
     * @function ascending
     * @syntax
     * function ascending(...propertyName: String): WixDataQuery
     * @summary Adds a sort to a query or sort, sorting by the specified properties in ascending order.
     * @param {...external:String} propertyName The properties used in the sort.
     * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
     * @description
     *  The `ascending()` function refines a `WixDataQuery` or `WixDataSort` to sort in ascending order of
     *  the specified properties. If you specify more than one property,
     *  `ascending()` sorts the results in ascending order by each property in the
     *  order they are listed.
     *
     *  You can sort the following types:
     *
     *  + Number: Sorts numerically.
     *  + Date: Sorts by date and time.
     *  + String: Sorts lexicographically, so `"abc"` comes after `"XYZ"`.
     *  + Reference: Compares by the ID of the referenced item as a String.
     *
     *
     *  If a property contains a number as a String, that value will be sorted
     *  alphabetically and not numerically. Items that do not have a value for the
     *  specified sort property are ranked lowest.
     * @snippet [SortMixin-ascending.es6=Add an ascending sort to a query]
     * @snippet [SortMixin-ascending_scenario.es6=Create a query, add an ascending sort, and run it]
     * @snippet [SortMixin-ascending_scenario_plus.es6=Create a query, add an ascending sort, and run it]
     * @memberof wix-data.WixDataSort
     * @instance
     */

    _createClass(_class2, [{
      key: 'ascending',
      value: function ascending(fields) {
        return this._sortClause('asc', '.ascending', arguments);
      }

      /**
       * @function descending
       * @syntax
       * function descending(...propertyName: String): WixDataQuery
       * @summary Adds a sort to a query or sort, sorting by the specified properties in descending order.
       * @param {...external:String} propertyName The properties used in the sort.
       * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
       * @description
       *  The `descending()` function refines a `WixDataQuery` or `WixDataSort` to sort in descending order of
       *  the specified properties. If you specify more than one property,
       *  `descending()` sorts the results in descending order by each property in the
       *  order they are listed.
       *
       *  You can sort the following types:
       *
       *  + Number: Sorts numerically.
       *  + Date: Sorts by date and time.
       *  + String: Sorts lexicographically, so `"abc"` comes before `"XYZ"`.
       *  + Reference: Compares by the ID of the referenced item as a String.
       *
       *
       *  If a property contains a number as a String, that value will be sorted
       *  alphabetically and not numerically. Items that do not have a value for the
       *  specified sort property are ranked lowest.
       * @snippet [SortMixin-descending.es6=Add an descending sort to a query]
       * @snippet [SortMixin-descending_scenario.es6=Create a query, add an descending sort, and run it]
       * @snippet [SortMixin-descending_scenario_plus.es6=Create a query, add an descending sort, and run it]
       * @memberof wix-data.WixDataSort
       * @instance
       */
    }, {
      key: 'descending',
      value: function descending(fields) {
        return this._sortClause('desc', '.descending', arguments);
      }
    }, {
      key: '_sortClause',
      value: function _sortClause(operatorSymbol, operatorName, args) {
        var orderBy = [];
        if (this.orderBy) {
          orderBy = (0, _utilsClone2['default'])(this.orderBy);
        }

        var appendClause = createAppendClauseFn(orderBy, operatorSymbol);
        var effectiveArgs = (0, _sharedTypeUtils.isArray)(args[0]) && args.length === 1 ? args[0] : Array.prototype.slice.call(args, 0);

        var _sortValidator$arityIsAtLeastOne$allStrings$validateAndAggregate = this._sortValidator(operatorName).arityIsAtLeastOne(args).allStrings(effectiveArgs).validateAndAggregate();

        var _sortValidator$arityIsAtLeastOne$allStrings$validateAndAggregate2 = _slicedToArray(_sortValidator$arityIsAtLeastOne$allStrings$validateAndAggregate, 2);

        var newInvalidArguments = _sortValidator$arityIsAtLeastOne$allStrings$validateAndAggregate2[0];
        var valid = _sortValidator$arityIsAtLeastOne$allStrings$validateAndAggregate2[1];

        if (valid) {
          effectiveArgs.forEach(appendClause);
        }

        return new this.constructor(Object.assign({}, this, { orderBy: orderBy, invalidArguments: newInvalidArguments }));
      }
    }, {
      key: '_sortValidator',
      value: function _sortValidator(operatorName) {
        return new SortValidator(operatorName, this.invalidArguments);
      }
    }]);

    return _class2;
  })(Base);
};

function createAppendClauseFn(destination, direction) {
  return function (field) {
    var spec = {};
    spec[field] = direction;
    destination.push(spec);
  };
}

var SortValidator = (function (_AggregatingValidator) {
  _inherits(SortValidator, _AggregatingValidator);

  function SortValidator(operatorName, previousInvalidArguments) {
    _classCallCheck(this, SortValidator);

    _get(Object.getPrototypeOf(SortValidator.prototype), 'constructor', this).call(this, previousInvalidArguments);
    this.operatorName = operatorName;
  }

  _createClass(SortValidator, [{
    key: 'allStrings',
    value: function allStrings(effectiveArgs) {
      var _this = this;

      return this.addValidation(function () {
        return effectiveArgs.every(_sharedTypeUtils.isString);
      }, function () {
        return _errors.messages.sortValidations.typeIsStringOrArrayOfStrings(_this.operatorName, effectiveArgs);
      });
    }
  }]);

  return SortValidator;
})(_utilsBaseValidator.AggregatingValidator);

exports['default'] = sortMixin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/sort/sortMixin.js
// module id = 36
// module chunks = 0